// extracted by mini-css-extract-plugin
export var orderDetails = "_re-2";
export var orderImage = "_re-1";
export var orderMeta = "_re-3";
export var orderSummary = "_re-0";
export var rightArrow = "_re-4";